/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import StableSelectorMixin from '../../globals/mixins/stable-selector';
import C4DContentBlock from '../content-block/content-block';
import styles from './content-block-simple.scss';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';

const { stablePrefix: c4dPrefix } = settings;

/**
 * Simple version of content block.
 *
 * @element c4d-content-block-simple
 */
@customElement(`${c4dPrefix}-content-block-simple`)
class C4DContentBlockSimple extends StableSelectorMixin(C4DContentBlock) {
  static get stableSelector() {
    return `${c4dPrefix}--content-block-simple`;
  }

  // `styles` here is a `CSSResult` generated by custom WebPack loader
  static get styles() {
    return css`
      ${super.styles}${styles}
    `;
  }
}

console.warn(
  'The content-block-simple component has been deprecated in favor of the content-section/block component. ' +
    'See content-section/block documentation for more information.'
);

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DContentBlockSimple;
